import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Col } from '@bingads-webui-react/layout';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withScope, } from '@bingads-webui-react/scope-service';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';

import { getLogoStyles } from './styles';
import { LogoImage } from './logo-image';

const preventFocusOnMouseClick = (e) => {
  // This will prevent the outline after a mouse click,
  // but still allow focus for keyboard users.
  e.preventDefault();
};

const Logo = (props) => {
  const {
    classes, i18n, onLogoClick, Image,
  } = props;

  return (
    <div className={classes.container}>
      <Col className={classes.item} >
        <div className={classes.logoContainer}>
          <Image
            tabIndex="0"
            aria-label={i18n.getString(_TL_('Logo with link to default landing page'))}
            role="link"
            onClick={onLogoClick}
            onMouseDown={preventFocusOnMouseClick}
            onKeyDown={submitEvent(() => onLogoClick())}
            className={classNames([classes.logo, 'global-menu-logo', onLogoClick !== _.noop ? classes.logoClickable : classes.logoUnclickable])}
            alt={i18n.getString(_TL_('Microsoft'))}
            classes={classes}
          />
        </div>
      </Col>
      <Col>
        <span className={classNames([classes.item, classes.text])}>Advertising</span>
      </Col>
    </div>
  );
};

Logo.propTypes = {
  classes: PropTypes.shape({
    logo: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onLogoClick: PropTypes.func,
  Image: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]).isRequired,
};

Logo.defaultProps = {
  onLogoClick: _.noop,
};

export const StyledLogo = withScope(withDefaultStyles(
  withI18nConsumer(Logo),
  getLogoStyles
));

export const StyledLogoWithImage = props => (<StyledLogo Image={LogoImage} {...props} />);
